import Select from 'react-select';
import  { useState, useMemo } from 'react';
import ConfirmModal from '../../ConfirmModal';
import ModifyDateModal from '../../ModifyDateModal';
import { today } from '../../../utils/utils';

const PanelBannerQueueManager = (props) => {
  const { api, appConfig, statePromoBanner, handleBackToBannerForm } = props
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [startCampaignDate, setStartCampaignDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const minEndDate = useMemo(() => {
    const t = today();
    if (!startCampaignDate) return t;
    return startCampaignDate < t ? t : startCampaignDate;
  }, [startCampaignDate]);

  const dateFields = useMemo(
    () => [
      {
        name: 'expiringCampaignDate',
        label: 'Fine campagna',
        value: endDate,
        min: minEndDate,
        onChange: setEndDate
      }
    ],
    [endDate, minEndDate]
  );

  const CustomMultiValue = ({ data }) => (
    <div className='tagValue'>
      <div
        className='label'
        onClick={(e) => {
          e.stopPropagation();
          handleTagClick(data);
        }}
      >
        {data.label}
      </div>
      <div
        {...props.innerProps}
        onClick={(e) => {
          e.stopPropagation();
          handleDeleteClick(data);
        }}
       className='delete'
      >
        <i className="nexi-icon-close"></i>
      </div>
    </div>
  );

  //======= Delete single banner =========
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;

    const payload = {
      key: {
        idPushTTL: itemToDelete.value,
        idJourney: itemToDelete.idJourney,
        version: itemToDelete.version
      }
    };

    const selectedVersion = statePromoBanner?.selectedCampaign?.version;

    const areSlotsEmpty = (slots) =>
      ['box1', 'box2', 'box3'].every((k) => Array.isArray(slots?.[k]) && slots[k].length === 0);

    try {
      const response = await api.deleteSingleTemplate(payload);
      if (!(response && response.status >= 200)) {
        return;
      }

      if (!selectedVersion) return;

      const runningConfResponse = await api.getRunningConfiguration(selectedVersion, statePromoBanner?.selectedCampaign?.templateType);
      if (
        runningConfResponse &&
        runningConfResponse.status >= 200 &&
        areSlotsEmpty(runningConfResponse.data?.slots)
      ) {
        handleBackToBannerForm();
      }
    } catch (err) {
    } finally {
      setShowDeleteModal(false);
    }
  };


  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  //======= Edit end date banner =========

  const handleTagClick = (item) => {
    setItemToEdit(item);
    setStartCampaignDate(item.startCampaignDate);
    setEndDate(item.expiringCampaignDate);
    setShowDateModal(true);
  };

  const handleSaveDate = async() => {
    if (!itemToEdit) {
      setShowDateModal(false);
      return;
    }
    const payload = {
      key: {
        idPushTTL: itemToEdit.value,
        idJourney: itemToEdit.idJourney,
        version: itemToEdit.version
      },
      expiringCampaignDate: endDate
    }
    const response = await api.updateTemplate(payload)
    if (response && response.status === 200) {
      api.getRunningConfiguration(statePromoBanner.selectedCampaign?.version, statePromoBanner.selectedCampaign?.templateType);
    }
    setShowDateModal(false);
  };

  const handleCancelDate = () => {
    setShowDateModal(false);
  };

  //======= Delete Campaign =========
  const handleDeleteCampaignClick = (e) => {
    e.preventDefault();
    setShowDeleteCampaignModal(true);
  };

  const handleConfirmDeleteCampaign = async() => {
    const payload = {
      idJourney: appConfig.idJourney,
      version: statePromoBanner?.selectedCampaign?.version,
      templateType: statePromoBanner?.selectedCampaign?.templateType
    }
    const response = await api.deleteCampaign(payload)
    if (response && response.status === 200) {
      api.getTemplate();
      handleBackToBannerForm();
    }
    setShowDeleteCampaignModal(false);
  }

  const onCancelDeleteCampaign = () => {
    setShowDeleteCampaignModal(false);
  };

  return(
    <>
      <form className="form-container queuBanner">
        <div className="queue">
          <h1 className="title">Visualizza Campagna</h1>
          <div className="form-row">
            <p>Box 1</p>
            <Select
              isMulti
              name="queue-box1"
              menuIsOpen={false}
              classNamePrefix="select"
              value={statePromoBanner.box1.map(item => ({
                value: item?.key?.idPushTTL,
                label: item?.templateInfo?.titleBanner || '',
                startCampaignDate: item?.templateInfo?.startCampaignDate || '',
                expiringCampaignDate: item?.templateInfo?.endCampaignDate || '',
                idJourney: item?.key?.idJourney,
                version: item?.key?.version,
                templateType: item?.templateInfo?.templateType
              })) || []}
              options={[]}
              closeMenuOnSelect={false}
              components={{
                DropdownIndicator: () => null,
                ClearIndicator: () => null,
                MultiValue: CustomMultiValue
              }}

            />
          </div>
          <div className="form-row">
            <p>Box 2</p>
            <Select
              isMulti
              name="queue-box2"
              menuIsOpen={false}
              value={statePromoBanner.box2.map(item => ({
                value: item.key.idPushTTL || '',
                label: item.templateInfo.titleBanner || '',
                startCampaignDate: item.templateInfo.startCampaignDate || '',
                expiringCampaignDate: item.templateInfo.endCampaignDate,
                idJourney: item.key.idJourney || '',
                version: item.key.version || ''
              })) || []}
              options={[]}
              classNamePrefix="select"
              components={{
                DropdownIndicator: () => null,
                ClearIndicator: () => null,
                MultiValue: CustomMultiValue
              }}
            />
          </div>
          <div className="form-row">
            <p>Box 3</p>
            <Select
              isMulti
              name="queue-box3"
              menuIsOpen={false}
              value={statePromoBanner.box3.map(item => ({
                value: item.key.idPushTTL || '',
                label: item.templateInfo.titleBanner || '',
                startCampaignDate: item.templateInfo.startCampaignDate || '',
                expiringCampaignDate: item.templateInfo.endCampaignDate,
                idJourney: item.key.idJourney || '',
                version: item.key.version || ''
              })) || []}
              options={[]}
              classNamePrefix="select"
              components={{
                DropdownIndicator: () => null,
                ClearIndicator: () => null,
                MultiValue: CustomMultiValue
              }}
            />
          </div>
        </div>
        <div className='buttonContainer'>
          <button className="button button--secondary"
            onClick={(e) => handleDeleteCampaignClick(e)}
            disabled={ 
              statePromoBanner && statePromoBanner.box1 &&
              statePromoBanner.box1.length === 0 &&
              statePromoBanner.box2 &&
              statePromoBanner.box2.length === 0 &&
              statePromoBanner.box3 && 
              statePromoBanner.box3.length === 0
            }
          >
                Cancella campagna
          </button>
        </div>
      </form>

 {/* DELETE TTL CONFIRM MODAL */}
      <ConfirmModal
        visible={showDeleteModal}
        title={`Sei sicuro di voler eliminare ${itemToDelete?.label ?? ''}?`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="CONFERMA"
        cancelText="INDIETRO"
      />

      {/* DELETE CAMPAIGN CONFIRM MODAL */}
      <ConfirmModal
        visible={showDeleteCampaignModal}
        title={`Sei sicuro di voler eliminare la versione ${statePromoBanner?.selectedCampaign?.version ?? ''}?`}
        onConfirm={handleConfirmDeleteCampaign}
        onCancel={onCancelDeleteCampaign}
        confirmText="CONFERMA"
        cancelText="INDIETRO"
      />

      <ModifyDateModal
        visible={showDateModal}
        title={`Modifica ${itemToEdit?.label ? itemToEdit?.label : ''} per la versione ${itemToEdit?.version ? itemToEdit?.version : ''}`}
        dateFields={dateFields}
        onSave={handleSaveDate}
        saveLabel='SALVA'
        onCancel={handleCancelDate}
        cancelLabel="INDIETRO"
      />
    </>
  )
}

export default PanelBannerQueueManager;
